import { render } from "./DateHistoryCard.vue?vue&type=template&id=5c8897e4&scoped=true"
import script from "./DateHistoryCard.vue?vue&type=script&lang=js"
export * from "./DateHistoryCard.vue?vue&type=script&lang=js"

import "./DateHistoryCard.vue?vue&type=style&index=0&id=5c8897e4&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8897e4"]])

export default __exports__